import * as types from '../actionTypes'

const initialState = {
  isAppInitialized: false,
  hasError: false,
  loadingCount: 0,
  // when true, loading will show only gray overlay.  Useful if the ui has a grid which is already
  // showing a loading gif
  suppressLoadingGif: undefined,
  startMoment: null,
  endMoment: null,
  isMocModeAvailable: false,
  isMocEnabled: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_ERROR: {
      return {...state, hasError: true}
    }
    case types.CLEAR_ERROR: {
      return {...state, hasError: false}
    }
    case types.LOADING_STARTED: {
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        suppressLoadingGif: action.suppressLoadingGif
      }
    }
    case types.LOADING_STOPPED: {
      if (state.loadingCount === 0) {
        return {...state, suppressLoadingGif: undefined}
      }
      return {
        ...state,
        loadingCount: state.loadingCount - 1,
        suppressLoadingGif: undefined
      }
    }
    case types.DOWNTIME_DATES: {
      return {
        ...state,
        startMoment: action.start,
        endMoment: action.end
      }
    }
    case types.SET_MOC_CHECK_RESPONSE: {
      return {
        ...state,
        isMocModeAvailable: action.payload.isMocReady,
        isMocEnabled: action.payload.isMocEnabled
      }
    }
    default:
      return state
  }
}
